import AppLogResourceModel from '../../generated/types/model/resource/AppLogResourceModel';

export default class AppLogResourceViewModel extends AppLogResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
